var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M22.284 14.75l1.1 1.253-1.105 1.253-15.166 16.391-2.71-2.508 15.163-16.394-0.005 2.503-15.641-17.004 2.715-2.501 15.648 17.007z"}})}
var staticRenderFns = []

export { render, staticRenderFns }